import { Container, Row, Col} from 'reactstrap';
import { motion } from 'framer-motion';

const TextBox = () => {
    return(
        <Container>
            <Row>
                <Col>
                    <motion.div 
                        className="text-box"
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.5, duration: 2, type: 'tween' }}
                        viewport={{ once: true }}>
                        <h3>Sample Text</h3>
                        <p className='rollingP'>
                            Nostrud tempor ex in do quis. Sint mollit esse culpa Lorem deserunt sint 
                            pariatur sint velit enim qui ea. Consectetur mollit pariatur qui dolor voluptate 
                            labore est aliquip ut reprehenderit magna ex. Quis ea cillum proident nostrud 
                            voluptate occaecat consectetur dolore. Adipisicing commodo aliqua ex anim et sint 
                            nisi esse in culpa consectetur commodo duis. Officia do velit in dolore mollit duis. 
                            Consequat tempor id enim dolor id voluptate enim fugiat deserunt id mollit.
                            Nostrud tempor ex in do quis. Sint mollit esse culpa Lorem deserunt sint 
                            pariatur sint velit enim qui ea. Consectetur mollit pariatur qui dolor voluptate 
                            labore est aliquip ut reprehenderit magna ex. Quis ea cillum proident nostrud 
                            voluptate occaecat consectetur dolore. Adipisicing commodo aliqua ex anim et sint 
                            nisi esse in culpa consectetur commodo duis. Officia do velit in dolore mollit duis. 
                            Consequat tempor id enim dolor id voluptate enim fugiat deserunt id mollit.
                            Nostrud tempor ex in do quis. Sint mollit esse culpa Lorem deserunt sint 
                            pariatur sint velit enim qui ea. Consectetur mollit pariatur qui dolor voluptate 
                            labore est aliquip ut reprehenderit magna ex. Quis ea cillum proident nostrud 
                            voluptate occaecat consectetur dolore. Adipisicing commodo aliqua ex anim et sint 
                            nisi esse in culpa consectetur commodo duis. Officia do velit in dolore mollit duis. 
                            Consequat tempor id enim dolor id voluptate enim fugiat deserunt id mollit.
                        </p>
                    </motion.div>
                </Col>
            </Row>
         </Container>
    );
};

export default TextBox;